export var PLAYROOM_REWARDS_SECTION_PAGE_KEY = 'playroom-rewards-section-page-key';